export const customColors = {
    primary: "#3AB397",
    secondary: "#B33A56",
    grey: "9A9A9A",
};
export default customColors;